<template>
    <div class="modal" v-if="loading">
        <div class="deletefile">
            <span @click="closebox" class="closefile">
                <img src="@/assets/Close Button.svg" />
            </span>
                <!-- <div class="d-flex justify-content-center align-items-center mt-4">
                <img src="@/assets/trash-can.svg" />
                </div> -->
            <div class="header d-flex justify-content-center align-items-center mt-2">
                <h6><strong>Cancel Upload</strong></h6>
            </div>
            <div class="cgn text-center my-2">
                <span>Do you want to cancel upload for <strong>{{ str_text(name) }}</strong></span>
            </div>
            <div class="save">
                <span class="btn-delete-permanently" @click="cancel">
                    Yes Cancel
                </span>

                <span class="btn-move-to-trash" @click="closebox"> 
                    Continue Upload
                </span>
            </div>
        </div>
    </div>
</template>
<style scoped>
.header {
    padding: .5em 0 0 0 !important;
}
.header h3 {
    font-size: 22px;
    font-weight: bold;
}
.save {
    margin-top: 0 !important;
}
.cgn {
    display: flex;
    flex-direction: column;
}
.cgn span {
    margin-bottom: .4em;
    font-size: 14px;
}
.deletefile {
    padding: 2em !important;
}
.modal div.deletefile {
    width: 420px !important;
}
.modal div.deletefile div {
    width: 100% !important;
    margin-left: 0 !important;
}
.save {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

.save span {
    flex: 1 !important;
}

.save .btn-move-to-trash {
    background: #3F96D1 !important;
    color: #fff !important;
    font-size: 13px !important;
}

.save .btn-delete-permanently {
    background: transparent !important;
    border: 1px solid #FC6D6C !important;
    font-size: 13px !important;
    color: #FC6D6C !important;
}

.save .btn-delete {
    background: transparent !important;
    border: 1px solid #FC6D6C !important;
    font-size: 13px !important;
    color: #FC6D6C !important;
}

.modal div.deletefile .closefile {
    top: 13px !important;
    right: 13px !important;
}
.permanent {
  box-shadow: 0px 5px 44px rgba(178, 189, 211, 0.24) !important;
  border-radius: 4px !important;
  display: flex !important;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.loading {
  box-shadow: 0px 5px 44px rgba(178, 189, 211, 0.24) !important;
  border-radius: 4px !important;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loading p:last-child {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn {
  cursor: pointer;
  border-radius: 8px;
  width: 132px !important;
  height: 42px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.cancel {
  border: 1px solid #3F96D1 !important;
  color: #3F96D1 !important;
}

.ok {
  background-color: #3F96D1 !important;
  color: #fff !important;
}
</style>

<script>
export default {
    data() {
        return {
            wait: true,
            loading: false,
            file_name: '',
            id: '',
            name: ''
        }
    },
    methods: {
        str_text (str) {
            if (str.length > 24) {
                let fSeg = str.substring(0, 5)
                let sSeg = str.substr(str.length - 7, str.length)

                return fSeg + '....' + sSeg
            }

            return str
        },
        loaderclose() {
            this.$parent.closeloader()
        },
        loaderbrowse() {
            this.$parent.browseloader()
        },
        logincall() {
            this.$parent.logincall()
        },
        load(id, name) {
            this.loading = true
            this.wait = true
            this.name = name
            this.id = id
        },
        cancel() {
            this.loading = false;
            this.wait = false;
            this.$parent.do_remove_upload(this.id);
        },
        closebox() {
            this.loading = false;
            this.wait = false;
        }
    }
}
</script>